<template>
  <div class="homepage-index-container">
    <!-- banner -->
    <div class="homepage-index-container-swiper">
      <el-carousel>
        <el-carousel-item v-for="(item, i) in bannerList" :key="i">
          <h3 class="small">
            <img
              :src="item.src"
              alt=""
              style="width: 100%; height: 100%"
              @click="$router.push({ name: item.name })"
            />
            <div class="blackbox" v-if="i == 0">
              <div class="blackbox-content">
                <p>{{ item.desc }}</p>
              </div>
            </div>
          </h3>
        </el-carousel-item>
      </el-carousel>
    </div>
    <!-- 智慧图书馆场景方案 -->
    <div class="homepage-index-container-main">
      <h2 class="homepage-index-container-main-title title-common">
        智慧图书馆场景方案
      </h2>
      <div
        class="homepage-index-container-main-swiper"
        @mouseover="showArrow = true"
        @mouseleave="showArrow = false"
      >
        <swiper :options="swiperOption">
          <swiper-slide v-for="(item, i) in sceneList" :key="i"
            ><img
              :src="item.pic"
              alt=""
              style="width:100%;height:100%"
              @click="$router.push({ name: item.name })"
            />
            <div class="desc">
              <h3>{{ item.title }}</h3>
              <p>{{ item.desc }}</p>
            </div>
          </swiper-slide>
          <div
            class="swiper-button-prev swiper-button-white"
            slot="button-prev"
            v-show="showArrow"
          ></div>
          <div
            class="swiper-button-prev swiper-button-white"
            slot="button-prev"
            v-show="showArrow"
          ></div>
          <div
            class="swiper-button-next swiper-button-white"
            slot="button-next"
            v-show="showArrow"
          ></div>
          <div
            class="swiper-button-next swiper-button-white"
            slot="button-next"
            style="right: 6.125rem"
            v-show="showArrow"
          ></div>
        </swiper>
      </div>
    </div>
    <!-- 智慧图书馆特色方案 -->
    <div class="homepage-index-container-special">
      <h2 class="homepage-index-container-special-title title-common">
        智慧图书馆特色方案
      </h2>
      <div class="homepage-index-container-special-floor1">
        <div
          class="homepage-index-container-special-floor1-box1"
          @click="$router.push({ name: 'public' })"
        >
          <div class="homepage-index-container-special-floor1-box1-pic">
            <img
              src="https://image.bookgo.com.cn/bgOfficial/index/home-special-pic.png"
              alt=""
            />
          </div>

          <h3 class="homepage-index-container-special-floor1-box1-title">
            <span>公共图书馆</span>
            <img
              src="https://image.bookgo.com.cn/bgOfficial/index/home-special-icon.png"
              alt=""
            />
          </h3>
          <p class="homepage-index-container-special-floor1-desc">
            新技术新视觉新窗口全方位展示
          </p>
        </div>
        <div
          class="homepage-index-container-special-floor1-box2"
          @click="$router.push({ name: 'primaryschool' })"
        >
          <div class="homepage-index-container-special-floor1-box2-pic">
            <img
              src="https://image.bookgo.com.cn/bgOfficial/index/home-special-pic2.png"
              alt=""
            />
          </div>

          <h3 class="homepage-index-container-special-floor1-box2-title">
            <span>中小学图书馆</span>
            <img
              src="https://image.bookgo.com.cn/bgOfficial/index/home-special-icon.png"
              alt=""
            />
          </h3>
          <p class="homepage-index-container-special-floor1-desc">
            用新技术打造新一代书香校园
          </p>
        </div>
      </div>
      <div class="homepage-index-container-special-floor2">
        <div
          class="homepage-index-container-special-floor2-box1"
          @click="$router.push({ name: 'highschool' })"
        >
          <div class="homepage-index-container-special-floor2-box1-pic">
            <img
              src="https://image.bookgo.com.cn/bgOfficial/index/home-special-pic3.png"
              alt=""
            />
          </div>

          <h3 class="homepage-index-container-special-floor2-box1-title">
            <span>高校图书馆</span>
            <img
              src="https://image.bookgo.com.cn/bgOfficial/index/home-special-icon.png"
              alt=""
            />
          </h3>
          <p class="homepage-index-container-special-floor2-desc">
            线下泛在阅读服务和线上云端图书馆平台服务
          </p>
        </div>
        <div
          class="homepage-index-container-special-floor2-box2"
          @click="$router.push({ name: 'enterprise' })"
        >
          <div class="homepage-index-container-special-floor2-box1-pic">
            <img
              src="https://image.bookgo.com.cn/bgOfficial/index/home-special-pic4.png"
              alt=""
            />
          </div>

          <h3 class="homepage-index-container-special-floor2-box1-title">
            <span>企事业图书馆</span>
            <img
              src="https://image.bookgo.com.cn/bgOfficial/index/home-special-icon.png"
              alt=""
            />
          </h3>
          <p class="homepage-index-container-special-floor2-desc">
            建设学习型企业、以文化管企业、兴企业
          </p>
        </div>
        <div
          class="homepage-index-container-special-floor2-box3"
          @click="$router.push({ name: 'city' })"
        >
          <div class="homepage-index-container-special-floor2-box1-pic">
            <img
              src="https://image.bookgo.com.cn/bgOfficial/index/home-special-pic5.png"
              alt=""
            />
          </div>

          <h3 class="homepage-index-container-special-floor2-box1-title">
            <span>城市书房</span>
            <img
              src="https://image.bookgo.com.cn/bgOfficial/index/home-special-icon.png"
              alt=""
            />
          </h3>
          <p class="homepage-index-container-special-floor2-desc">
            用物联网、大数据等打造的智能24h阅读空间
          </p>
        </div>
      </div>
    </div>
    <!-- 智慧文旅方案 -->
    <div class="homepage-index-container-cuturalTour">
      <h2 class="homepage-index-container-cuturalTour-title title-common">
        智慧文旅方案
      </h2>
      <div class="homepage-index-container-cuturalTour-main">
        <div class="homepage-index-container-cuturalTour-main-pic">
          <div
            class="homepage-index-container-cuturalTour-main-pic-box1"
            @mouseover="
              pic1 = true;
              pic2 = false;
              pic3 = false;
            "
          >
            <div class="contentbox" v-if="pic1">
              <h3>数字文化馆</h3>
              <i>打造数字体验趣味文化馆</i>
            </div>
            <img
              src="https://image.bookgo.com.cn/bgOfficial/home/home-cutural-bignum.png"
              alt=""
              v-if="pic1"
            />
            <img
              src="https://image.bookgo.com.cn/bgOfficial/index/home-cutural-small-num.png"
              alt=""
              v-if="!pic1"
            />
            <img
              src="https://image.bookgo.com.cn/bgOfficial/index/home-index-arrow.png"
              alt=""
              v-if="!pic1"
              class="homepage-index-container-cuturalTour-main-pic-box1-arrow"
            />
            <p v-if="!pic1">数字文化馆</p>
          </div>
          <div
            class="homepage-index-container-cuturalTour-main-pic-box2"
            @mouseover="
              pic2 = true;
              pic1 = false;
              pic3 = false;
            "
          >
            <div class="contentbox" v-if="pic2">
              <h3>智慧博物馆</h3>
              <i>打造虚拟立体云端科技博物馆</i>
            </div>
            <img
              src="https://image.bookgo.com.cn/bgOfficial/home/home-cutural-bigmuseum.png"
              alt=""
              v-if="pic2"
            />

            <img
              src="https://image.bookgo.com.cn/bgOfficial/index/home-cultura-small-museuml.png"
              alt=""
              v-if="!pic2"
            />
            <img
              src="https://image.bookgo.com.cn/bgOfficial/index/home-index-arrow.png"
              alt=""
              v-if="!pic2"
              class="homepage-index-container-cuturalTour-main-pic-box2-arrow"
            />
            <p v-if="!pic2">智慧博物馆</p>
          </div>
          <div
            class="homepage-index-container-cuturalTour-main-pic-box3"
            @mouseover="
              pic3 = true;
              pic2 = false;
              pic1 = false;
            "
          >
            <div class="contentbox" v-if="pic3">
              <h3>智慧文旅</h3>
              <i>打造智慧文旅融合新方向</i>
            </div>
            <img
              src="https://image.bookgo.com.cn/bgOfficial/home/home-cutural-bigtour.png"
              alt=""
              v-if="pic3"
            />
            <img
              src="https://image.bookgo.com.cn/bgOfficial/index/home-cutural-small-tour.png"
              alt=""
              v-if="!pic3"
            />
            <img
              src="https://image.bookgo.com.cn/bgOfficial/index/home-index-arrow.png"
              alt=""
              v-if="!pic3"
              class="homepage-index-container-cuturalTour-main-pic-box3-arrow"
            />
            <p v-if="!pic3">智慧文旅</p>
          </div>
        </div>
      </div>
    </div>
    <!-- 为什么选择我们 -->
    <div class="homepage-index-container-reason">
      <h2 class="homepage-index-container-reason-title title-common">
        为什么选择我们
      </h2>
      <ul class="homepage-index-container-reason-content">
        <li>
          <img
            src="https://image.bookgo.com.cn/bgOfficial/index/home-why-pic1.png"
            alt=""
          />
          <h3>紧跟时代顺应潮流</h3>
          <p>紧跟行业新时代新技术，顺应国家新政策新趋势</p>
        </li>
        <li>
          <img
            src="https://image.bookgo.com.cn/bgOfficial/index/home-why-pic2.png"
            alt=""
          />
          <h3>软硬件一体化</h3>
          <p>硬件为载体，软件为灵魂，算法为核心</p>
        </li>
        <li>
          <img
            src="https://image.bookgo.com.cn/bgOfficial/index/home-why-pic3.png"
            alt=""
          />
          <h3>方案和服务一体化</h3>
          <p>提供从技术、到场景、到运营一体化服务</p>
        </li>
        <li>
          <img
            src="https://image.bookgo.com.cn/bgOfficial/index/home-why-pic4.png"
            alt=""
          />
          <h3>大数据分析科学决策</h3>
          <p>帮助客户通过数据分析结果来进行科学管理决策</p>
        </li>
        <li>
          <img
            src="https://image.bookgo.com.cn/bgOfficial/index/home-why-pic5.png"
            alt=""
          />
          <h3>定制系统平台搭建</h3>
          <p>提供定制公众号、官网、软件功能等定制化搭建</p>
        </li>
        <li>
          <img
            src="https://image.bookgo.com.cn/bgOfficial/index/home-why-pic6.png"
            alt=""
          />
          <h3>一对一专业售后</h3>
          <p>提供及时响应完善健全的售后服务</p>
        </li>
      </ul>
    </div>
    <!-- 愿景理念 -->
    <div class="homepage-index-container-hope">
      <div class="homepage-index-container-hope-idea">
        <!-- <img
          src="https://image.bookgo.com.cn/bgOfficial/index/home-index-hope.png"
          alt=""
          class="homepage-index-container-hope-idea-pic"
        /> -->
        <h2 class="homepage-index-container-hope-idea-title title-common">
          愿景理念
        </h2>
        <p>博库专注于图书馆与文旅行业的技术服务商</p>
        <p>通过移动互联网、大数据、智能感知、人工智能等新兴技术</p>
        <p>
          为图书馆、文化馆、博物馆、旅游景区等提供科技、泛在、高效的整体解决方案
        </p>
      </div>
    </div>
    <!-- 动态中心 -->
    <div class="homepage-index-container-dynamic">
      <h2 class="homepage-index-container-dynamic-title title-common">
        动态中心
      </h2>
      <div class="homepage-index-container-dynamic-content">
        <div
          class="homepage-index-container-dynamic-content-left"
          @click="goDetail(articleList[0] ? articleList[0] : '')"
        >
          <img :src="articleList[0] ? articleList[0].cover : ''" alt="" />
          <h3>{{ articleList[0] ? articleList[0].title : "" }}</h3>
          <p>
            {{ articleList[0] ? articleList[0].summary : "" }}
            <span class="homepage-index-container-dynamic-content-left-time">{{
              articleList[0] ? articleList[0].update_time : ""
            }}</span>
          </p>
          <div
            class="homepage-index-container-dynamic-content-left-button"
            @click="$router.push({ name: 'dynamic-center' })"
          >
            more >
          </div>
        </div>
        <div class="homepage-index-container-dynamic-content-right">
          <ul>
            <li
              v-for="(item, i) in articleList"
              :key="i"
              @click="goDetail(item)"
            >
              <div class="homepage-index-container-dynamic-content-right-time">
                <h4>{{ item.day }}</h4>
                <h5>{{ item.date }}</h5>
              </div>
              <div class="homepage-index-container-dynamic-content-right-news">
                <h4>{{ item.title }}</h4>
                <p>
                  {{ item.summary }}
                </p>
              </div>
            </li>
          </ul>
        </div>
      </div>
    </div>
    <!-- 合作中心 -->
    <div class="homepage-index-container-cooperation">
      <h2 class="homepage-index-container-cooperation-title title-common">
        合作中心
      </h2>
      <div class="homepage-index-container-cooperation-fatherbox clear">
        <div class="homepage-index-container-cooperation-fatherbox-content">
          <div
            class="homepage-index-container-cooperation-fatherbox-content-pic"
            v-for="(item, i) in picList"
            :key="i"
          >
            <img :src="item.pic" alt="" />
          </div>
        </div>
        <div class="homepage-index-container-cooperation-fatherbox-content1">
          <div
            class="homepage-index-container-cooperation-fatherbox-content1-pic"
            v-for="(item, i) in picList"
            :key="i"
          >
            <img :src="item.pic" alt="" />
          </div>
        </div>
      </div>
    </div>
    <toTop />
  </div>
</template>

<script>
import { list } from "../../api/homepage/index";
import toTop from "../../assets/components/toTop";
import moment from "moment";
export default {
  data() {
    return {
      swiperOption: {
        initialSlide: 1,
        slidesPerView: "4",
        // height: 547,
        // spaceBetween: 1,
        centeredSlides: true,
        centeredSlidesBounds: true,
        // observeParents: true,
        // observer: true,
        navigation: {
          nextEl: ".swiper-button-next",
          prevEl: ".swiper-button-prev",
        },
        box1Width: "48.875rem",
      },
      showArrow: false,
      pic1: true,
      pic2: false,
      pic3: false,
      sceneList: [
        {
          pic:
            "https://image.bookgo.com.cn/bgOfficial/index/home-scene-banner1.png",
          title: "智慧图书馆",
          desc: "管理、服务、空间、馆舍四大智慧化",
          name: "totalSolution",
        },
        {
          pic:
            "https://image.bookgo.com.cn/bgOfficial/index/home-scene-banner3.png",
          title: "RFID图书馆",
          desc: "新型智能化、自动化管理模式的图书馆",
          name: "RFID",
        },
        {
          pic:
            "https://image.bookgo.com.cn/bgOfficial/index/home-scene-banner2.png",
          title: "图书馆总分馆",
          desc: "双系统架构、通借通还流通体系",
          name: "headBranch",
        },
        {
          pic:
            "https://image.bookgo.com.cn/bgOfficial/index/home-scene-banner4.png",
          title: "泛在图书馆",
          desc: "帮助图书馆与读者建立更好的连接",
          name: "Ubiquitous",
        },
        {
          pic:
            "https://image.bookgo.com.cn/bgOfficial/index/home-scene-banner5.png",
          title: "智能感知图书馆",
          desc: "打造个性化、模型化、数据化图书馆",
          name: "tofeel",
        },
        {
          pic:
            "https://image.bookgo.com.cn/bgOfficial/index/home-scene-banner6.png",
          title: "互动体验图书馆",
          desc: "建设互动化、趣味化、多样化图书馆",
          name: "interact",
        },
        {
          pic:
            "https://image.bookgo.com.cn/bgOfficial/index/home-scene-banner7.png",
          title: "图书馆物联网",
          desc: "推动馆舍管理进入智能化时代",
          name: "webthings",
        },
        {
          pic:
            "https://image.bookgo.com.cn/bgOfficial/index/home-scene-banner8.png",
          title: "图书馆消毒防疫",
          desc: "人流管控、刷脸测温、消毒杀菌",
          name: "antiepidemic",
        },
      ],
      bannerList: [
        {
          src:
            "https://image.bookgo.com.cn/bgOfficial/home/home-index-banner1.png",
          desc: "智慧图书馆与文旅行业的 产业互联网服务商",
          name: "",
        },
        {
          src: "https://image.bookgo.com.cn/bgOfficial/index/home-banner2.png",
          desc: "",
          name: "primaryschool",
        },
        {
          src: "https://image.bookgo.com.cn/bgOfficial/index/home-banner3.png",
          desc: "",
          name: "city",
        },
      ],
      picList: [
        {
          pic:
            "https://image.bookgo.com.cn/bgOfficial/index/home-cooperator1.png",
        },
        {
          pic:
            "https://image.bookgo.com.cn/bgOfficial/index/home-cooperator2.png",
        },
        {
          pic:
            "https://image.bookgo.com.cn/bgOfficial/index/home-cooperator3.png",
        },
        {
          pic:
            "https://image.bookgo.com.cn/bgOfficial/index/home-cooperator4.png",
        },
        {
          pic:
            "https://image.bookgo.com.cn/bgOfficial/index/home-cooperator5.png",
        },
        {
          pic:
            "https://image.bookgo.com.cn/bgOfficial/index/home-cooperator6.png",
        },
        {
          pic:
            "https://image.bookgo.com.cn/bgOfficial/index/home-cooperator7.png",
        },
        {
          pic:
            "https://image.bookgo.com.cn/bgOfficial/index/home-cooperator8.png",
        },
        {
          pic:
            "https://image.bookgo.com.cn/bgOfficial/index/home-cooperator9.png",
        },
        {
          pic:
            "https://image.bookgo.com.cn/bgOfficial/index/home-cooperator10.png",
        },
        {
          pic:
            "https://image.bookgo.com.cn/bgOfficial/index/home-cooperator11.png",
        },
        {
          pic:
            "https://image.bookgo.com.cn/bgOfficial/index/home-cooperator12.png",
        },
        {
          pic:
            "https://image.bookgo.com.cn/bgOfficial/index/home-cooperator13.png",
        },
        {
          pic:
            "https://image.bookgo.com.cn/bgOfficial/index/home-cooperator14.png",
        },
        {
          pic:
            "https://image.bookgo.com.cn/bgOfficial/index/home-cooperator15.png",
        },
        {
          pic:
            "https://image.bookgo.com.cn/bgOfficial/index/home-cooperator16.png",
        },
        {
          pic:
            "https://image.bookgo.com.cn/bgOfficial/index/home-cooperator17.png",
        },
        {
          pic:
            "https://image.bookgo.com.cn/bgOfficial/index/home-cooperator18.png",
        },
        {
          pic:
            "https://image.bookgo.com.cn/bgOfficial/index/home-cooperator19.png",
        },
        {
          pic:
            "https://image.bookgo.com.cn/bgOfficial/index/home-cooperator20.png",
        },
      ],
      // 动态中心的文章列表
      articleList: [],
      day: "",
      date: "",
    };
  },
  components: {
    toTop,
  },
  computed: {},
  created() {
    let params = {
      aid: 2,
      page_size: 4,
      page: 1,
      app_type: 1,
      board_code: "official.news",
    };
    list(params).then((res) => {
      // console.log(res);
      if (res.code == 0) {
        this.articleList = res.data.list;
        res.data.list.forEach((item) => {
          item.summary = item.summary.substring(0, 54) + "...";
          item.update_time = moment(item.update_time * 1000).format(
            "YYYY-MM-DD"
          );
          item.day = item.update_time.substring(8, 10);
          item.date = item.update_time.substring(0, 7);
        });
      }
    });
  },
  methods: {
    goDetail(item) {
      // console.log(item);
      if (item.is_link) {
        window.open(item.jump_url);
      } else {
        this.$router.push({
          name: "dynamic-center-detail",
          query: { cat_id: item.cat_id, id: item.id },
          params: { content: item.content },
        });
      }
    },
  },
};
</script>

<style lang="scss">
@import "../../assets/scss/homepage.scss";
</style>
